import { render, staticRenderFns } from "./custReport.vue?vue&type=template&id=251ac4aa&scoped=true&"
import script from "./custReport.vue?vue&type=script&lang=js&"
export * from "./custReport.vue?vue&type=script&lang=js&"
import style0 from "./custReport.vue?vue&type=style&index=0&id=251ac4aa&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251ac4aa",
  null
  
)

export default component.exports